import { REST_HOSTNAME } from './Config';

const managedPicturePath = /^\/verbaschola\/exercise-images\/([1-9][0-9]*)\/[0-9a-f]{32}$/;

/** Extract the asset ID only from a complete managed picture URL. */
export function lessonImageAssetId(src: string): number | null {
    let path = src;
    if (!src.startsWith('/')) {
        try {
            const url = new URL(src);
            if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.search || url.hash) return null;
            path = url.pathname;
        } catch { return null; }
    }
    const match = managedPicturePath.exec(path);
    if (!match) return null;
    const id = Number(match[1]);
    return Number.isSafeInteger(id) ? id : null;
}

/** Render current and historical managed pictures through the configured API host. */
export function lessonImageUrl(src: string): string {
    if (managedPicturePath.test(src)) return new URL(src, REST_HOSTNAME).toString();
    try {
        const url = new URL(src);
        if (['http:', 'https:'].includes(url.protocol) && !url.username && !url.password && !url.search && !url.hash
            && managedPicturePath.test(url.pathname)) return new URL(url.pathname, REST_HOSTNAME).toString();
    } catch { /* Keep non-URL source strings unchanged for the caller's validation. */ }
    return src;
}
